import { render, staticRenderFns } from "./ContactScreen.vue?vue&type=template&id=6b902076"
import script from "./ContactScreen.vue?vue&type=script&lang=js"
export * from "./ContactScreen.vue?vue&type=script&lang=js"
import style0 from "./ContactScreen.vue?vue&type=style&index=0&id=6b902076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports